// extracted by mini-css-extract-plugin
export default {"wrapper":"xpa-z","play":"ypa-z"};